module.exports = __webpack_public_path__ + "static/media/11.db37c0fc.svg";